import React, {useEffect} from 'react';
import './ConnectCalendarPage.scss';
import {Text} from "../../modules";
import {useTranslation} from "react-i18next";
import {GoogleMeetIcon, OutlookCalendarIcon} from "../../image";
import {Button} from "../../modules/Button";
import {GoogleOAuthProvider, useGoogleLogin} from "@react-oauth/google";
import {useDispatch, useSelector} from "react-redux";
import {useCalendarActions} from "../Integrations/hooks";
import {history} from "../../utils/history";
import {ROUTERS_MAP} from "../../utils/routes";
import {CheckTokenService} from "../../redux/actions";
import AlertPermissionBox from "../Integrations/components/AlertPermissionBox/AlertPermissionBox";

const ConnectCalendarPage = () => {
    const {t} = useTranslation();
    const userCalendars = useSelector(state => state.userCalendars);
    const {OutlookAuth} = useCalendarActions();
    const dispatch = useDispatch();

    const isCheckToken = async () => {
        try {
            const response = await dispatch(CheckTokenService());
            if (response.status !== 200) {
                history.push(ROUTERS_MAP.LOGIN)
            }
        } catch (e) {
            history.push(ROUTERS_MAP.LOGIN)
            console.error(e)
        }
    }

    useEffect(() => {
        isCheckToken();
    }, []);

    return (
        <div className='connect-calendar'>
            <span className='connect-calendar--title'>Secretopus</span>
            <div className='connect-calendar__container'>
                <Text size="f30" font="bold">{t('calendar_connect')}</Text>
                <Text size="f14" font="book" color="#9898A6">{t('connect_calendar_desc')}</Text>
                <AlertPermissionBox/>
                <div className="services__list">
                    <div
                        className={`service__item`}
                    >

                        <div className="service__item--container">
                            <GoogleMeetIcon/>
                            <div className="service__item--info">
                                <Text size="f16" font="liteMedium">{t('calendar_settings_user_title')}</Text>
                            </div>
                            <>
                                {userCalendars?.clientId ?
                                <GoogleOAuthProvider clientId={userCalendars?.clientId || ''}>
                                    <GoogleButton
                                        handleOnSuccess={(response) => {
                                            localStorage.setItem('google_scope', JSON.stringify(response))
                                            history.push(`${ROUTERS_MAP.KNOWLEDGE_DATA}?isGoogleCalendarAdd=true`);
                                        }}
                                        t={t}
                                    />
                                </GoogleOAuthProvider>
                                    :
                                    null
                                }
                            </>
                        </div>
                        <Text font="book" size="f12" color="#9898A6">
                            {t('google_calendar_description')}
                        </Text>
                    </div>
                    <div
                        className={`service__item`}
                    >
                        <div className="service__item--container">
                            <OutlookCalendarIcon/>
                            <div className="service__item--info">
                                <Text size="f16" font="liteMedium">Microsoft Outlook</Text>
                            </div>
                            <Button
                                text={t('connect')}
                                variant="ghost"
                                size="xs"
                                onClick={OutlookAuth}
                            />
                        </div>
                        <Text font="book" size="f12" color="#9898A6">
                            {t('outlook_calendar_description')}
                        </Text>
                    </div>
                </div>
                <div className='connect-calendar__footer'>
                    <Text
                        onClick={() => history.push(ROUTERS_MAP.COPILOT)}
                        size="f12" font="book" color="#7F7F7F"
                        style={{marginTop: 40, cursor: 'pointer'}}>{t('later')}</Text>
                </div>
            </div>
        </div>
    );
};


function GoogleButton({handleOnSuccess, t}) {
    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'https://www.googleapis.com/auth/calendar.readonly',
        onSuccess: async (codeResponse) => {
            handleOnSuccess(codeResponse)
        },
        onError: errorResponse => console.log(errorResponse),
    });
    return (
        <Button
            onClick={login}
            text={t('connect')}
            variant="ghost"
            size="xs"
        />
    );
}

export default ConnectCalendarPage;